export default (state) => {
  return state.screens.Dashboard.basicDashboardData;
};
